/**
 * Decide whether an Axios failure belongs to an authenticated request.
 * Public/login requests may legitimately return 401; only requests that actually
 * carried an Authorization header participate in refresh / session-expiry flow.
 */
function hasAuthorizationHeader(error) {
  const headers = error?.config?.headers;
  if (!headers) return false;
  if (typeof headers.get === 'function') {
    return Boolean(headers.get('Authorization') || headers.get('authorization'));
  }
  return Boolean(headers.Authorization || headers.authorization);
}

export function shouldAttemptSessionRefresh(error) {
  if (error?.response?.status !== 401) return false;
  if (!hasAuthorizationHeader(error)) return false;
  if (error?.config?.__paydaaiRefreshAttempted) return false;
  const url = String(error?.config?.url || '');
  return !url.includes('/api/auth/refresh');
}

export function shouldTriggerSessionExpiry(error) {
  if (error?.response?.status !== 401) return false;
  return hasAuthorizationHeader(error);
}
